<template>
  <div v-if="info && info.form" class="jin-form-Base">
    <el-form ref="form" class="el-form-flex" :model="info.form" :rules="info.rules">
      <Input v-model="info.form.user_name" label="姓名" prop="user_name" />
      <Input v-model="info.form.phone_number" label="手机号码" prop="phone_number" />
      <Select v-model="info.form.sex" :options="info.sex" label="性别" prop="sex" />
      <Input v-model.number="info.form.age" label="年龄" prop="age" />
      <Input v-model="info.form.email" label="邮箱" prop="email" />
      <Input v-model="info.form.highest_education" label="最高学历" prop="highest_education" />
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
    }
  },
  methods: {
    submitForm() {
      let curr = true
      this.$refs.form.validate((valid) => {
        curr = valid
      })
      return curr
    },
    resetForm() {
      this.$refs.form.resetFields()
      this.info.form = {}
    }
  }
}
</script>
